// removed by extract-text-webpack-plugin
module.exports = {"Toolbar":"Toolbar__Toolbar__-hash--base64-5-","Logo":"Toolbar__Logo__-hash--base64-5-","DesktopOnly":"Toolbar__DesktopOnly__-hash--base64-5-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigation/Toolbar/Toolbar.css
// module id = 60
// module chunks = 0